import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {
  MatNavList,
  MatListItem,
  MatListItemAvatar,
  MatListItemTitle,
  MatListItemMeta,
  MatDivider,
} from '@angular/material/list';
import { CoreSelectors } from '@next/core-lib';
import { RootState } from '@next/core-lib/app';
import { PageToolbarComponent } from '@next/core-lib/components';
import { DialogService, DIALOG_RETURN_TYPES } from '@next/core-lib/dialog';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ViewMode } from 'src/app/shared/models/shared.model';

import { DosatorSetting } from '../../models/settings.model';
import * as settingActions from '../../store/actions/settings.actions';
import { getDosatorSettings } from '../../store/selectors/settings.selectors';

import { DosatorSettingItemDialogComponent } from '../dosator-setting-item-dialog/dosator-setting-item-dialog.component';

@Component({
  selector: 'app-dosator-setting-overview',
  templateUrl: 'dosator-setting-overview.component.html',
  imports: [
    PageToolbarComponent,
    NgIf,
    MatNavList,
    NgFor,
    MatListItem,
    MatIcon,
    MatListItemAvatar,
    MatListItemTitle,
    MatListItemMeta,
    MatIconButton,
    MatDivider,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class DosatorSettingOverviewComponent {
  dosatorSettings$ = this.store.select(getDosatorSettings);
  isLoading$: Observable<boolean> = this.store.select(CoreSelectors.selectLoading);

  constructor(
    private readonly store: Store<RootState>,
    private readonly dialog: DialogService,
    private readonly locale: LocaleService,
  ) {}

  addDialog() {
    this.dialog
      .form(DosatorSettingItemDialogComponent, {
        confirmButton: true,
        confirmButtonText: this.locale.translate('save'),
        altButton: true,
        altButtonText: this.locale.translate('settings.dosator-setting.save-and-create-new'),
        altButtonColor: 'primary',
        altButtonIcon: 'save',
        pushHistoryState: false,
        dosatorsettingId: null,
        viewMode: ViewMode.EDIT,
      })
      .subscribe((result) => {
        if (result.status === DIALOG_RETURN_TYPES.confirm) {
          this.store.dispatch(
            settingActions.upsertDosatorSettingRequest({
              dosatorSetting: result.result.dosatorSetting,
            }),
          );
        }
      });
  }

  openDosatorSettingEdit(dosatorSettingId: number) {
    this.store.dispatch(
      settingActions.setSelectedDosatorSetting({
        dosatorSettingId,
      }),
    );
    this.dialog
      .form(DosatorSettingItemDialogComponent, {
        confirmButton: true,
        confirmButtonText: this.locale.translate('save'),
        altButton: true,
        altButtonText: this.locale.translate('settings.dosator-setting.save-and-create-new'),
        altButtonColor: 'primary',
        altButtonIcon: 'save',
        pushHistoryState: false,
        dosatorSettingId,
        viewMode: ViewMode.EDIT,
      })
      .subscribe((result) => {
        if (result.status === DIALOG_RETURN_TYPES.confirm) {
          this.store.dispatch(
            settingActions.upsertDosatorSettingRequest({
              dosatorSetting: result.result.dosatorSetting,
            }),
          );
        }
      });
  }

  delete(event: Event, dosatorSetting: DosatorSetting) {
    event.preventDefault();
    event.stopImmediatePropagation();

    if (dosatorSetting && dosatorSetting.id) {
      this.store.dispatch(settingActions.deleteDosatorSettingWithConfirmation({ dosatorSetting }));
    }
  }
}
